import { ArchivedProjects } from '~/@pages_investing/projects/archived-projects/ArchivedProjects'
import { RunningProjects } from '~/@pages_investing/projects/running-projects/RunningProjects'

function HomePage() {
  return (
    <>
      <RunningProjects />
      <ArchivedProjects />
    </>
  )
}

export default HomePage
